import Header from "../../../shared/components/Header"
import Login from "../../../auth/Login"
import logooficial from '../../../images/logo_speed_order_oficial__img.png'
import styles from './Home.module.css'


function Home(){
    return(
        <div className={styles.homeContainer}>

            <Login/>

        </div>
    )
}

export default Home